import { createContext } from "react";

const AuthContext = createContext(undefined);

export default AuthContext;
